<script setup lang="ts">

</script>

<template>
  <div relative w-full overflow-hidden>
    <img src="/images/image-167-live.webp" h-640px w-full object-cover animated animated-slow lg:h-956px md:h-640px style="animation-name: scale-in">

    <div absolute inset-0 top-100px text-center lg:top-180px>
      <p class="text-40px text-[rgba(255,255,255,0.4)] font-bold lh-130% lg:text-120px sm:text-70px">
        COMING SOON
      </p>

      <LiveSearchBar mx-auto mt-124px />

      <div mt-82px>
        <h1 text-40px font-bold uppercase lg:text-100px xl:text-120px class="lh-100%">
          MISS W LIVE
        </h1>
        <h2 mt-20px text-16px font-bold uppercase lg:text-24px>
          FEATURED LIVE STREAMING<br>COMING SOON
        </h2>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
